module.exports = __webpack_public_path__ + "img/Logo.9a2d3222.svg";